// src/components/ui/modal/ReportModal.tsx
'use client';

import React, { useState } from 'react';
import IconModal from '@/components/ui/modal/IconModal';
import {
  Root as ModalRoot,
  Dialog as ModalDialog,
  Content as ModalContent,
  Title as ModalTitle,
} from './Modal';

export type ShareModalProps = {
  /** 是否開啟 */
  open: boolean;
  /** 關閉事件 */
  onClose: () => void;

  /** Modal 標題（預設：檢舉貼文） */
  title?: string;
  /** Modal 裡面上方的描述文字（可選） */
  description?: React.ReactNode;

  /** 顯示大小（沿用 Modal.Dialog 的 size） */
  size?: 'sm' | 'md' | 'lg' | 'xl';
  /** 是否點擊幕後即可關閉（預設 true） */
  closeOnBackdrop?: boolean;
  /** 是否鎖捲動（預設 true） */
  lockScroll?: boolean;
  /** 自訂 Dialog 額外 class */
  dialogClassName?: string;
  /** 自訂 Content 額外 class */
  contentClassName?: string;
};

const ReportModal: React.FC<ShareModalProps> = ({
  open,
  onClose,
  title = '檢舉貼文',
  description,
  size = 'md',
  closeOnBackdrop = true,
  lockScroll = true,
  dialogClassName,
  contentClassName,
}) => {
  const [modalType, setModalType] = React.useState<'success' | null>(null);
  const [textValue, setTextValue] = useState('');

  const handleChange = (event: React.ChangeEvent<HTMLTextAreaElement>) => {
    setTextValue(event.target.value);
  };

  return (
    <>
      {/* 主檢舉 Modal */}
      <ModalRoot
        open={open}
        onClose={onClose}
        closeOnBackdrop={closeOnBackdrop}
        lockScroll={lockScroll}
        className="modal-static"
      >
        <ModalDialog size={size} centered className={dialogClassName}>
          <ModalContent className={contentClassName}>
            {/* Header */}
            <div className="modal-header">
              <ModalTitle className="fw-bold">{title}</ModalTitle>
              <button type="button" className="btn-close" aria-label="Close" onClick={onClose} />
            </div>

            {/* Body */}
            <div className="modal-body">
              {description && <p className="text-center">{description}</p>}

              <div className="form-check d-flex align-items-center mb-5">
                <input
                  className="form-check-input me-2"
                  type="radio"
                  name="reason"
                  id="report-1"
                  value="option1"
                  defaultChecked
                  readOnly
                />
                <label className="form-check-label" htmlFor="report-1">
                  侵犯我的肖像權或著作權
                </label>
              </div>

              <div className="form-check d-flex align-items-center mb-5">
                <input
                  className="form-check-input me-2"
                  type="radio"
                  name="reason"
                  id="report-2"
                  value="option2"
                  readOnly
                />
                <label className="form-check-label" htmlFor="report-2">
                  內容不適當（暴力、色情或誤導性內容）
                </label>
              </div>

              <div className="form-check mb-3">
                <div className="d-flex align-items-center mb-2">
                  <input
                    className="form-check-input me-2"
                    type="radio"
                    name="reason"
                    id="report-3"
                    value="option3"
                    readOnly
                  />
                  <label className="form-check-label" htmlFor="report-3">
                    其他原因
                  </label>
                </div>
                <div>
                  <textarea
                    id="report"
                    className="form-control"
                    value={textValue}
                    onChange={handleChange}
                    rows={5}
                    cols={30}
                    placeholder="請填寫其他檢舉內容..."
                  />
                </div>
              </div>

              <div className="text-center">
                <button
                  className="btn btn-red mb-3"
                  type="button"
                  onClick={() => setModalType('success')}
                >
                  送出
                </button>
              </div>
            </div>
          </ModalContent>
        </ModalDialog>
      </ModalRoot>

      {/* 送出成功的提示 IconModal */}
      <IconModal
        show={modalType === 'success'}
        variant="success"
        size="md"
        title="送出檢舉成功！"
        autoCloseSeconds={2}
        onClose={() => setModalType(null)}
      />
    </>
  );
};

export default ReportModal;
